import { ArrowRight } from "lucide-react";
import { useEligibility } from "@/components/landing/EligibilityContext";

// Primary emerald-gradient CTA that launches the inquiry modal
export const EligibilityButton = ({
  label = "Inquire Now",
  className = "",
  size = "md",
  shimmer = true,
  testId = "inquire-btn",
}) => {
  const { open } = useEligibility();
  const sizes = {
    sm: "min-h-[44px] px-5 text-sm",
    md: "min-h-[52px] px-7 text-base",
    lg: "min-h-[58px] px-8 text-base sm:text-lg",
  };
  return (
    <button
      onClick={open}
      data-testid={testId}
      className={`btn-emerald group inline-flex items-center justify-center gap-2 rounded-full font-bold text-white transition-transform duration-200 hover:scale-[1.03] active:scale-95 ${
        shimmer ? "shimmer-cta" : ""
      } ${sizes[size]} ${className}`}
    >
      {label}
      <ArrowRight
        size={18}
        className="transition-transform duration-200 group-hover:translate-x-1"
      />
    </button>
  );
};
